import React from 'react';

// components
import styles from './ShippingDetailsServicesTable.scss';
import Checkmark from 'dibs-vg/dist/react/checkmark';
import { shippingModal as messages } from '../shippingMessages';

// helpers
import classnames from 'classnames';

//cell classes
const cell = classnames(styles.serviceCell);
const headerCell = classnames(styles.serviceHeadCell, styles.serviceCell);

const methods = ['courier', 'standardExpress', 'frontDoor', 'whiteGlove'];

const services = [
    {
        label: 'Full insurance',
        courier: true,
        standardExpress: true,
        frontDoor: true,
        whiteGlove: true,
    },
    {
        label: 'Item collection and packaging',
        courier: true,
        standardExpress: true,
        frontDoor: true,
        whiteGlove: true,
    },
    {
        label: 'Shipping',
        courier: true,
        standardExpress: true,
        frontDoor: true,
        whiteGlove: true,
    },
    {
        label: 'Handling for large or oversized items',
        courier: false,
        standardExpress: false,
        frontDoor: true,
        whiteGlove: true,
    },
    {
        label: 'Delivery by appointment',
        courier: false,
        standardExpress: false,
        frontDoor: false,
        whiteGlove: true,
    },
    {
        label: 'Placement in room of choice',
        courier: false,
        standardExpress: false,
        frontDoor: false,
        whiteGlove: true,
    },
    {
        label: 'Unpacking and inspection',
        courier: false,
        standardExpress: false,
        frontDoor: false,
        whiteGlove: true,
    },
    {
        label: 'Packaging removal',
        courier: false,
        standardExpress: false,
        frontDoor: false,
        whiteGlove: true,
    },
    {
        label: 'Minor assembly',
        courier: false,
        standardExpress: false,
        frontDoor: false,
        whiteGlove: true,
    },
];

export function ShippingDetailsServicesTable() {
    const checkmarkImage = <Checkmark className={styles.checkmarkImage} />;
    return (
        <div className={styles.servicesTableContainer}>
            <table className={styles.servicesTable}>
                <thead>
                    <tr>
                        <th className={headerCell}>{messages.servicesIncluded}</th>
                        <th className={headerCell}>{messages.courier}</th>
                        <th className={headerCell}>{messages.standardExpress}</th>
                        <th className={headerCell}>{messages.frontDoor}</th>
                        <th className={headerCell}>{messages.whiteGlove}</th>
                    </tr>
                </thead>
                <tbody>
                    {services.map(service => {
                        return (
                            <tr key={service.label}>
                                <td className={cell}>{messages.label(service.label)}</td>
                                {methods.map(method => (
                                    <td className={cell} key={`${service.label}-${method}`}>
                                        {service[method] ? checkmarkImage : ''}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <p>{messages.someShippingMethods}</p>
        </div>
    );
}
